import { useMutation } from "@apollo/client";
import {
  Button,
  Container,
  Loader,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CONFIRM_EMAIL } from "../../../apis/lambda/GraphQL/Email/mutations";
import TikTokLoginButton from "../../../components/TikTokLoginButton/TikTokLoginButton";

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [verified, setVerified] = useState(false);

  const confirmationToken = searchParams.get("confirmationToken");
  const email = searchParams.get("email");

  const [verifyEmail] = useMutation(CONFIRM_EMAIL);

  useEffect(() => {
    if (confirmationToken && email) {
      verifyEmail({
        variables: { confirmationToken: confirmationToken, email },
      })
        .then(() => {
          setVerified(true);
          setVerifying(false);
          notifications.show({
            title: "Email verified!",
            message: "Your account has been verified successfully.",
            color: "green",
            icon: <IconCheck size={16} />,
          });
        })
        .catch(() => {
          setVerifying(false);
          notifications.show({
            title: "Verification failed",
            message: "Invalid or expired verification link.",
            color: "red",
            icon: <IconX size={16} />,
          });
        });
    } else {
      setVerifying(false);
      // setVerified(true);
    }
  }, [confirmationToken, email, verifyEmail]);

  return (
    <Container size="xs" py="xl">
      <Paper p="xl" radius="lg" shadow="md" withBorder>
        <Stack align="center" gap="lg">
          {verifying ? (
            <>
              <Loader size="lg" />
              <Title order={2}>Verifying your email...</Title>
            </>
          ) : verified ? (
            <>
              <IconCheck size={48} color="green" />
              <Title order={2}>Email Verified!</Title>
              <Text ta="center" c="dimmed">
                Your account has been verified successfully.
              </Text>
              <Paper withBorder p="md" radius="md">
                <Stack gap="xs">
                  <Text fw={500}>What's next?</Text>
                  <Text size="sm">
                    - Link your TikTok account so brands can see your data!
                  </Text>
                  <Text size="sm">
                    - Start discovering brands to reach out to!
                  </Text>
                </Stack>
              </Paper>
              <Stack>
                <TikTokLoginButton />
                <Button to={"/discover"} component={Link}>
                  Discover Brands
                </Button>
              </Stack>
            </>
          ) : (
            <>
              <IconX size={48} color="red" />
              <Title order={2}>Verification Failed</Title>
              <Text ta="center">
                The verification link is invalid or expired.
              </Text>
              <Button onClick={() => navigate("/signup")} color="orange">
                Back to Signup
              </Button>
            </>
          )}
        </Stack>
      </Paper>
    </Container>
  );
}

export default VerifyEmailPage;
